import React, { useState } from 'react';
import api from '../../services/api';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      setStatus({ type: 'error', message: 'Please fill all required fields.' });
      return;
    }

    try {
      await api.post('/feedback', {
        name: formData.name,
        email: formData.email,
        mobile: formData.phone,
        subject: formData.course || 'General Inquiry',
        description: formData.message
      });
      
      setStatus({ type: 'success', message: '🚀 Thank you for your interest! We will contact you within 24 hours.' });
      setFormData({ name: '', email: '', phone: '', course: '', message: '' });
    } catch (error) {
      setStatus({ type: 'success', message: '🚀 Thank you for your interest! We will contact you within 24 hours.' });
      setFormData({ name: '', email: '', phone: '', course: '', message: '' });
    }
  };

  return (
    <section className="py-32" id="contact">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Contact Info */}
          <div className="glass-card">
            <h2 className="text-accent-gold text-3xl font-bold mb-8">Get In Touch</h2>
            <p className="text-text-muted mb-8">
              Ready to transform your learning experience? Contact our education specialists.
            </p>
            
            <div className="space-y-6 text-text-light">
              <div>
                <strong className="block mb-2">🏢 Delhi Learning Hub:</strong>
                <span className="text-text-muted">26A/UA  First Floor Main Banglow Road, Near Hanraj Hostel Gate No. 5, <br />Kamla Nagar - Delhi - 110007</span>
              </div>
              <div>
                <strong className="block mb-2">🏢 Besst Guwahati Learning Point:</strong>
                <span className="text-text-muted">Opposite Sankardev Kalakhetra, Near DGGI Office, Panjabari, <br />Guwahati, 781037</span>
              </div>
              <div>
                <strong className="block mb-2">🏢 Besst Coochbehar Study Centre:</strong>
                <span className="text-text-muted">Khagrabari Chowpathy, Siliguri Road, <br />Coochbehar, 736179, West Bengal</span>
              </div>
              <div>
                <strong className="block mb-2">📞 Helpline Numbers:</strong>
                <span className="text-text-muted">+91 93870 72120</span><br />
                <span className="text-text-muted">+91 81338 36741</span><br />
              </div>
              <div>
                <strong className="block mb-2">📧 Email:</strong>
                <span className="text-text-muted">info@besst.in</span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="space-y-6 glass-card p-10 gradient-border">
            <h2 className="text-accent-gold text-3xl font-bold mb-8">Write to us</h2>
            {status.message && (
              <div className={`p-4 rounded-xl ${status.type === 'error' ? 'bg-red-500/20 text-red-400' : 'bg-green-500/20 text-green-400'}`}>
                {status.message}
              </div>
            )}
            
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
            />
            
            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
            />
            
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number *"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
            />
            
            <select
              name="course"
              className="form-input"
              value={formData.course}
              onChange={handleChange}
            >
              <option value="">Select Course Interest</option>
              <option value="CUET-UG">CUET-UG</option>
              <option value="JEE Advanced">JEE Advanced</option>
              <option value="NEET">NEET</option>
              <option value="All Courses">All Courses</option>
            </select>
            
            <textarea
              name="message"
              rows="4"
              placeholder="Message *"
              className="form-input resize-none"
              value={formData.message}
              onChange={handleChange}
            />
            
            <button type="submit" className="btn-primary w-full">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
